import { B } from "../../design/tokens";

export default function Tag({ text, onDark = false }) {
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
      <div style={{ width: 28, height: 1.5, background: onDark ? B.mist : B.azure, borderRadius: 2 }} />
      <span style={{
        fontFamily: "'Space Grotesk', sans-serif", fontSize: 11, fontWeight: 600,
        letterSpacing: 3, textTransform: "uppercase",
        color: onDark ? B.mist : B.azure,
      }}>{text}</span>
    </div>
  );
}
